import type {
  AxiosHeaders,
  AxiosResponseHeaders,
  RawAxiosResponseHeaders,
} from "axios";
import { versionBannerStore } from "../components/Version/versionBannerStore.ts";
import { getGitCommitHash } from "../utils/version.ts";
import { GIT_COMMIT_HASH_HEADER } from "./header.ts";

export const checkVersionCompatibility = (
  headers: AxiosHeaders | AxiosResponseHeaders | RawAxiosResponseHeaders,
) => {
  const serverGitCommitHash = headers[GIT_COMMIT_HASH_HEADER];
  const clientGitCommitHash = getGitCommitHash();

  // XXX: We make exception for development environment, as we don't have the different environment variables `GIT_COMMIT_HASH` or `VITE_GIT_COMMIT_HASH` set
  if (!clientGitCommitHash) return;

  if (serverGitCommitHash !== clientGitCommitHash) {
    versionBannerStore.openShowVersionBanner();
  }
};
